import { React, useState, useContext } from "react";
import AddIcon from "@mui/icons-material/Add";
import "../css/EscortOfficerList.css";
import Modal from "../../../components/elements/Modal";
import {
  ClearanceStatus as Status,
  TRIP_PHASE,
} from "../../../utils/constants";
import AddOfficerModal from "../../../components/elements/AddOfficerModal";
import { StorageContext } from "../../../services/StorageProvider";
import { useFormData } from "../../../helper/FormDataProvider";
import { hasAirportAccess } from "../../../utils/Utils";
import deleteIcon from "../../../assets/images/delete_icon.svg";
import DeleteModal from "../../../components/elements/DeleteModal";
import editIcon from "../../../assets/images/edit_icon.svg";

const EscortDepartureOfficersList = ({
  officers,
  onAddOfficer,
  onEditOfficer,
  onDeleteOfficer,
  clearanceStatus,
  airportId,
}) => {
  const { userData } = useFormData();
  const { airportData } = useContext(StorageContext);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [officerToDelete, setOfficerToDelete] = useState(null);
  const [editingOfficer, setEditingOfficer] = useState(null);

  // Check if user has access to the departure airport
  const hasDepartureAirportAccess = hasAirportAccess(
    userData,
    airportData,
    airportId
  );

  const handleAddOfficeClick = () => {
    setIsModalOpen(true);
  };

  const handleDeleteClick = (index) => {
    if (officers.length <= 2) {
      // Don't allow deletion if only 2 officers remain
      return;
    }
    setOfficerToDelete(index);
    setIsDeleteModalOpen(true);
  };
  const confirmDeleteOfficer = () => {
    if (officerToDelete !== null) {
      onDeleteOfficer(officerToDelete);
    }
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };

  const cancelDelete = () => {
    setIsDeleteModalOpen(false);
    setOfficerToDelete(null);
  };

  const handleEditClick = (officer, index) => {
    setEditingOfficer({ ...officer, index });
    setIsModalOpen(true);
  };

  const isApproved =
    clearanceStatus === Status.PAID ||
    clearanceStatus === Status.CLEARANCE_REJECTED ||
    clearanceStatus === Status.CANCELLED ||
    clearanceStatus === Status.CORRECTION_REQUESTED;

  return (
    <div>
      <div className="escort-departure-officers-list" data-testid="escort-officers-list">
        <div className="escort-officers-header">
          <p>Added Officers</p>
          {!isApproved && (
            <button
              className={`escort-add-officer-btn ${!hasDepartureAirportAccess ? 'disabled' : ''}`}
              onClick={hasDepartureAirportAccess ? handleAddOfficeClick : undefined}
              disabled={!hasDepartureAirportAccess}
              data-testid="add-officer-btn"
            >
              <AddIcon />
              Add Officer
            </button>
          )}
        </div>
        <div className="escort-officers-box" data-testid="escort-officers-box">
          {officers.length > 0 ? (
            officers.map((officer, index) => (
              <div
                className="escort-officer"
                data-testid="escort-officer"
                key={index}
              >
                <div className="escort-officer-details">
                  <p>
                    {officer.name} - {officer.hoursWorked} hrs
                  </p>
                </div>
                {!isApproved && hasDepartureAirportAccess && (
                  <div className="escort-officer-actions">
                    <img
                      className="escort-edit-icon"
                      src={editIcon}
                      alt="edit icon"
                      onClick={() => handleEditClick(officer, index)}
                    />
                    {officers.length > 2 && (
                      <img
                        className="escort-delete-icon"
                        src={deleteIcon}
                        alt="delete icon"
                        onClick={() => handleDeleteClick(index)}
                      />
                    )}
                  </div>
                )}
              </div>
            ))
          ) : (
            <p className="no-officers-message" data-testid="no-officers-message">No officers added</p>
          )}
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingOfficer(null);
        }}
      >
        <AddOfficerModal
          tripPhase={TRIP_PHASE.DEPARTURE}
          onAddOfficer={(updatedOfficer) => {
            if (editingOfficer) {
              onEditOfficer(editingOfficer.index, updatedOfficer[0]);
            } else {
              onAddOfficer(updatedOfficer);
            }
          }}
          onClose={() => {
            setIsModalOpen(false);
            setEditingOfficer(null);
          }}
          airportId={airportId}
          existingOfficers={officers.filter((_, i) =>
            editingOfficer ? i !== editingOfficer.index : true
          )}
          editingOfficer={editingOfficer}
        />
      </Modal>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={cancelDelete}
        onDelete={confirmDeleteOfficer}
      />
    </div>
  );
};

export default EscortDepartureOfficersList;
